import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonGridService } from 'src/app/shared/services/common-grid.service';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';
import { ReportService } from '../service/report.service';
import { ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';


@Component({
  selector: 'app-call-recording',
  templateUrl: './call-recording.component.html',
  styleUrls: ['./call-recording.component.scss']
})
export class CallRecordingComponent implements OnInit , OnDestroy{
  public studyId:string="";

  constructor(
    public cgService:CommonGridService,
    public sidePanel:SidePanelService,
    public reportService:ReportService,
    public route:ActivatedRoute,
    public notify:NotifierService

  ) { }

  ngOnInit(): void {
    this.cgService.gridInitFor = "callRecording";
    this.cgService.initCommonGrid();
    this.route.paramMap.subscribe(params => {
      this.studyId = params.get('uuid');
      this.reportService.getRepositoryDetail(this.studyId);
    });
    setTimeout(() =>{
      this.getCallRecordingData(true,false);
      setTimeout(() =>{
        this.getBufferDataStorage();
      },1000);
    },100)
  }

  ngOnDestroy(){
    this.reportService.isCallRecording = false;
    this.reportService.callRecordingDataContainer = [];
    this.reportService.callDispositionContainer = [];
    this.reportService.callRecordingApiSurveyId = -1;
  }

  


  getCallRecordingData(isInit:boolean,isBufer:boolean){
    let body = {};
    body['page'] = this.cgService.page;
    body['page_size'] = this.cgService.page_size;
    body['survey_id'] = parseInt(localStorage.getItem('api_survey_id'));
    body['study_id'] = this.studyId;
    if(localStorage.getItem('callRecordingUserContainer')){
      body['type'] = JSON.parse(localStorage.getItem('callRecordingUserContainer'));
    }
    if(localStorage.getItem('callDispositionContainer')){
      body['call_Desposition'] = JSON.parse(localStorage.getItem('callDispositionContainer'));
    }
    if(this.cgService.serachBy && this.cgService.serachBy.length > 1){
      body['searchBy'] = this.cgService.serachBy;
    }
    this.cgService.getCallRecordingData(body,isInit,isBufer);
  };

  getBufferDataStorage(isScroll?){
    if(!isScroll){
      this.cgService.page++;
    }
    if(this.cgService.page <= this.cgService.gridPageTotal){
      this.getCallRecordingData(false,true);
    }
  }


  onSearchChange($event){
    if($event.str.length > 1){
      this.cgService.serachBy = $event.str
      this.cgService.gridDataContainer = [];
      this.cgService.bufferArr = [];
      this.cgService.page = 1;
      this.cgService.page_size = 20;
      this.getCallRecordingData(false,false);
    }else{
      this.cgService.serachBy = $event.str
      this.cgService.gridDataContainer = [];
      this.cgService.bufferArr = [];
      this.cgService.page = 1;
      this.cgService.page_size = 20;
      this.getCallRecordingData(false,false);
    }
    setTimeout(() =>{
      this.getBufferDataStorage();
    },1000)
  }


  onScroll($event){
    if(this.cgService.page <= this.cgService.gridPageTotal){
      this.cgService.gridDataContainer = [...this.cgService.gridDataContainer,...this.cgService.bufferArr];
      this.cgService.page++;
    }
    this.getBufferDataStorage(true);
  }


  // applyFilter($event){
  //   if(this.checkForFilter()){
  //     this.cgService.page = 1;
  //     this.cgService.page_size = 20;
  //     this.cgService.gridDataContainer = [];
  //     this.cgService.bufferArr = [];
  //     // filters:this.cgService.appliedFilter,
    
  //     this.getCallRecordingData(true,false);
  //     setTimeout(() =>{
  //       this.getBufferDataStorage();
  //     },1000)
  //   }
  // }


  // checkForFilter(){
  //   if(Object.keys(this.cgService.appliedFilter).length){
  //     let isDateValid = true;
  //     Object.keys(this.cgService.appliedFilter).forEach(key =>{
  //       if(!this.cgService.appliedFilter[key].length){
  //         delete this.cgService.appliedFilter[key];
  //       }
  //       if(key === 'date'){
  //         if(this.cgService.appliedFilter[key]){
  //           this.cgService.appliedFilter[key].forEach(va =>{
  //             if(!va){
  //               this.notify.notify('error','Please Select Start or End Date');
  //               isDateValid = false;
  //               return;
  //             }
  //           })
  //         }
  //       }
  //     })
  //     return Object.keys(this.cgService.appliedFilter).length && isDateValid ? true : false;
  //   }else{
  //     return false;
  //   }
  // }

  


  

}
